export default {
  musicalGenres: 'Musical Genres',
  seeMore: 'See more',
  artists: 'Artists',
  songs: 'Songs',
  topMusicalGenres: 'Top musical genres',
  additionalGenres: 'Additional genres',
  topArtists: 'Top Artists',
  additionalArtists: 'Additional Artists',
  topSongs: 'Top Songs',
  additionalSongs: 'Additional Songs',
  likes: 'Likes',
  peopleLikes: 'People likes',
  additionalLikes: 'Additional Likes',
  peoplePerJourneyStatus: 'People per Journey status'
}
